import styled from "styled-components";

import Field from "src/components-v2/Field";

import { colors, typography } from "src/assets/styles/settings";

export default styled(Field)`
  height: 70px;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 20px;

  &::placeholder {
    letter-spacing: 1px;
  }

  &::-webkit-input-placeholder {
    color: ${colors.light_grey};
    font-weight: ${typography.font_weight.bold};
    font-size: 1.5rem;
    text-align: center;
    letter-spacing: 1px;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }

  @media (max-width: 640px) {
    &::-webkit-input-placeholder {
      color: ${colors.light_grey};
      font-weight: ${typography.font_weight.bold};
      font-size: ${typography.font_size.medium};
      text-align: center;
      letter-spacing: 1px;
    }
  }
`;
